import { StateNode, TLPointerEventInfo } from "tldraw"

export class CustomIdle extends StateNode {
  static override id = "custom-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("custom-drawing", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
